export default __webpack_public_path__ + "static/media/screen_dropbox_4.b5ddd230.png";